import React from "react";
import ReactDOM from "react-dom";
import "normalize.css";
import "./index.styl";
import App from "./App";
import state from "./state";
// import registerServiceWorker from './registerServiceWorker';
// registerServiceWorker();

const urlBaseRegex = /[^/]+\/\/[^/]+\//;

const Congress = root => {
  ReactDOM.render(<App />, root);
};

// Find the current script to extract the base URL for API requests.
[].slice.call(document.getElementsByTagName("script")).some(script => {
  let url;
  if (script.src.indexOf("ifaw-congress") !== -1) {
    url = script.baseUri;

    if (url == null) {
      url = script.src.match(urlBaseRegex)[0];
    }

    if (url == null) {
      url = window.location.href.match(urlBaseRegex)[0];
    }

    if (url != null) {
      state.apiURL = url.replace(/\/$/, "");
    }
  }

  return url;
});

module.exports = Congress;



// WEBPACK FOOTER //
// ./src/index.js